// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"two-image_wrapper__no5kU","title":"two-image_title__aBzRu","text":"two-image_text__Iwyc2","grid":"two-image_grid__SHraU"};